const SESSION_KEY = 'saloni_gf_analytics_sid';

function getSessionKey() {
  try {
    let s = localStorage.getItem(SESSION_KEY);
    if (!s) {
      s =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `gf-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(SESSION_KEY, s);
    }
    return String(s).slice(0, 64);
  } catch {
    return '';
  }
}

function basePayload(filters = {}) {
  return {
    session_key: getSessionKey(),
    recipient: String(filters.recipient || 'any').slice(0, 64),
    category: String(filters.category || 'any').slice(0, 64),
    group: String(filters.group || 'any').slice(0, 64),
    budget: String(filters.budget || 'any').slice(0, 32),
  };
}

/**
 * Fire-and-forget analytics (no PII).
 * @param {Record<string, unknown>} payload
 */
export function trackGiftFinderEvent(payload) {
  if (!payload || typeof payload !== 'object') return;
  try {
    fetch('/api/gift_finder_analytics.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* ignore */
  }
}

export function trackGiftFinderStepView(step, filters) {
  trackGiftFinderEvent({
    ...basePayload(filters),
    action: 'step_view',
    step: String(step || ''),
  });
}

export function trackGiftFinderSelect(step, value, filters) {
  trackGiftFinderEvent({
    ...basePayload(filters),
    action: 'select',
    step: String(step || ''),
    meta: { value: String(value || '') },
  });
}

export function trackGiftFinderResults(filters, resultCount) {
  trackGiftFinderEvent({
    ...basePayload(filters),
    action: 'results',
    step: 'results',
    result_count: Math.max(0, Number(resultCount) || 0),
  });
}

export function trackGiftFinderProductClick(productId, filters) {
  trackGiftFinderEvent({
    ...basePayload(filters),
    action: 'product_click',
    step: 'results',
    product_id: String(productId || '').slice(0, 191),
  });
}

export function trackGiftFinderWiden(relaxedLabel, filters) {
  trackGiftFinderEvent({
    ...basePayload(filters),
    action: 'widen',
    step: 'results',
    meta: { relaxed: String(relaxedLabel || '') },
  });
}
